/* eslint-disable no-unused-vars */
import React from 'react';
import style from './action.module.scss';
import isFunction from 'lodash-es/isFunction';
import DeleteIcon from 'icons/delete';
import EditIcon from 'icons/edit';
import DownloadIcon from 'icons/download';
import { ContextAction } from '../contextActions';
import GearIcon from 'icons/gear';
import SharpIcon from 'icons/sharp';
import UserIcon from 'icons/user';
import AddImageIcon from 'icons/addImage';

const icons = {
  delete: <DeleteIcon className={'action-icon'} />,
  edit: <EditIcon className={'action-icon'} />,
  download: <DownloadIcon className={'action-icon'} />,
  replace: <AddImageIcon className={'action-icon'} />,
  toProfile: <UserIcon className={'action-icon'} />,
  toTags: <SharpIcon className={'action-icon'} />,
  toAdmin: <GearIcon className={'action-icon'} />,
  toUpload: <AddImageIcon className={'action-icon'} />,
};

const texts = {
  delete: 'Удалить',
  edit: 'Редактировать',
  download: 'Скачать',
  replace: 'Заменить',
  toProfile: 'Профиль',
  toTags: 'Список тегов',
  toAdmin: 'Администрирование',
  toUpload: 'Загрузить контент',
};

export default function ActionComponent({ action }: { action: ContextAction }) {
  return (
    <div
      className={style.action}
      onClick={() => {
        if (isFunction(action.handler)) {
          action.handler();
        }
      }}
    >
      {icons[action.type]}
      <span className={style.text}>{texts[action.type]}</span>
    </div>
  );
}
